"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import { useAuth } from "@tillix/tx-core/react";
import { Button } from "@tillix/ui-atoms/button";
import { KeyIcon } from "lucide-react";
import { type FieldValues, useFormContext } from "react-hook-form";
import { useT } from "@/features/i18n/hooks/use-t";

export default function LoginWithPasskey<TFieldValues extends FieldValues>() {
  const authStore = useAuth();
  const form = useFormContext<TFieldValues>();
  const router = useRouter();
  const [isSigningIn, setIsSigningIn] = useState(false);
  const { t } = useT();
  const { t: tErrors } = useT("errors");

  const handlePasskeySignIn = async () => {
    setIsSigningIn(true);
    try {
      const result = await authStore.signInWithPasskey({});

      if (result.error) {
        form.setError("root", {
          message:
            typeof result.error.message === "string"
              ? result.error.message
              : (result.error.message?.message ?? tErrors("backend.unknown")),
        });
      } else {
        router.refresh();
      }
    } finally {
      setIsSigningIn(false);
    }
  };

  return (
    <Button
      className="bg-primary text-white uppercase hover:bg-tenant-howard-county-secondary-light-green/80"
      disabled={isSigningIn}
      onClick={handlePasskeySignIn}
      type="button"
    >
      {t("auth.loginWithPasskeys")} <KeyIcon />
    </Button>
  );
}
